/**
 * Useful when repeatedly updating properties which should be rendered before the next update.
 * E.g. A progress bar or temporarily updating a property to update it again after one render frame.
 *
 * By default LitElement renders at microtask timing, which is before the browser paints; if you enqueue more
 * microtasks (e.g. by incrementing the slider) from a microtask (e.g. after awaiting the updateComplete promise,
 * which also runs at microtask timing before paint), your loop will be blocking paint since it is not
 * yielding to a task, only to a microtask.
 * That is easy to solve... if you want to run an animation, you should use requestAnimationFrame and only increment
 * the slider once per frame.
 *
 * @link https://github.com/Polymer/lit-element/issues/365#issuecomment-448324296
 * @return {Promise}
 */
export async function renderFrame() {
	return new Promise(r => requestAnimationFrame(r));
}